import React from 'react'

import {
    StyledInHouseLinks,
    StyledLink,
} from 'component-library/content/TheWestHeader/TheWestHeader.styled'
import { InHouseLink } from 'component-library/navigation/TheWestMainNavigation/components/in_house_links/in_house_links'

export interface Props {
    items: InHouseLink[]
}

export const InHouseLinks: React.FC<Props> = ({ items }) => (
    <StyledInHouseLinks className="in-house-links">
        {items.map(({ text, link, target, rel }) => (
            <StyledLink key={link} to={link} rel={rel} target={target}>
                {text}
            </StyledLink>
        ))}
    </StyledInHouseLinks>
)
InHouseLinks.displayName = 'InHouseLinks'
